import {
  Filter, Form, Mask, PageHeader, Styles,
} from '@/components'
import usePageTitle from '@/hooks/usePageTitle'
import React from 'react'
import { useParams } from 'react-router-dom'
import mapTitles from './mapTitles'
import ClinicalCaresQuickFilter from '../components/QuickFilter'
import ListStatus from './List'

function ClinicalCareStatus({ title }) {
  usePageTitle({ title })
  const params = useParams()
  const titleParams = mapTitles(params.status)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title={titleParams.title}
        icon={titleParams.icon}
        rightAction={() => (
          <Filter
            initialValues={{
              'animal.name_cont': '',
              'animal.uid_eq': '',
              'clinic.fullName_cont': '',
              'clinic.documentNumber_eq': '',
              'author.fullName_cont': '',
            }}
            title="Filtrar atendimentos"
            renderForm={({ setFieldValue }) => (
              <>
                <div className="divider text-center" data-content="Pet" />
                <Form.Group>
                  <Form.Label className="text-sm" htmlFor="animal.name_cont">
                    Nome do animal
                  </Form.Label>
                  <Form.ValidationField
                    name="['animal.name_cont']"
                    className="input-sm"
                    id="animal.name_cont"
                    autoComplete="none"
                    placeholder="Totó da Silva"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="text-sm" htmlFor="animal.uid_eq">
                    RGA
                  </Form.Label>
                  <Form.ValidationField name="['animal.uid_eq']">
                    {({ field }) => (
                      <Mask.Rga
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...field}
                        className="input-sm"
                        placeholder="####.####.####.####.####"
                        id="['animal.uid_eq']"
                        onAccept={(value) => {
                          setFieldValue("['animal.uid_eq']", value)
                        }}
                      />
                    )}
                  </Form.ValidationField>
                </Form.Group>
                <div className="divider text-center" data-content="Clínica" />
                <Form.Group>
                  <Form.Label
                    className="text-sm"
                    htmlFor="clinic.fullName_cont"
                  >
                    Nome da clínica
                  </Form.Label>
                  <Form.ValidationField
                    name="['clinic.fullName_cont']"
                    className="input-sm"
                    id="clinic.fullName_cont"
                    autoComplete="none"
                    placeholder="Clínica do pet"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label
                    className="text-sm"
                    htmlFor="clinic.documentNumber_eq"
                  >
                    CPF/CNPJ da clínica
                  </Form.Label>
                  <Form.ValidationField name="['clinic.documentNumber_eq']">
                    {({ field }) => (
                      <Mask.CpfCnpj
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...field}
                        className="input-sm"
                        placeholder="CPF/CNPJ da clínica"
                        id="['clinic.documentNumber_eq']"
                        onAccept={(value) => {
                          setFieldValue("['clinic.documentNumber_eq']", value)
                        }}
                      />
                    )}
                  </Form.ValidationField>
                </Form.Group>
                <div
                  className="divider text-center"
                  data-content="Solicitante"
                />
                <Form.Group>
                  <Form.Label
                    className="text-sm"
                    htmlFor="author.fullName_cont"
                  >
                    Nome do solicitante
                  </Form.Label>
                  <Form.ValidationField
                    name="['author.fullName_cont']"
                    className="input-sm"
                    id="author.fullName_cont"
                    autoComplete="none"
                    placeholder="Solicitante"
                  />
                </Form.Group>
              </>
            )}
          />
        )}
      />
      <ClinicalCaresQuickFilter />
      <ListStatus title={titleParams.title} />
    </Styles.Container>
  )
}

export default ClinicalCareStatus
